import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import { get, size, map, orderBy, omitBy, includes, isEmpty } from 'lodash';
import { Main } from 'base-components';
import { withRouter } from 'react-router';
import LeftFilters from './LeftFilters';
import ShopperNotificationsTable from './ShopperNotificationsTable';
import { NotFound, Pagination, FlexContainer, Container, Row, Loading, If, Button, Drawer } from '../../common';
import GetShopperNotifications from '../../graphql/getShopperNotifications';
import NotificationForm from './NotificationForm';

const ShopperNotifications = ({ session }) => {
    const sessionSalesChannel = orderBy(map(get(session, 'salesChannels'), ({ name, store, id, kind }) => ({ label: `${store} - ${name}`, value: id, kind })), ['label'], ['asc']);
    const [currentPage, setCurrentPage] = useState(null);
    const [pageSize, setPageSize] = useState(100);
    const [totalRecords, setTotalRecords] = useState(0);
    const [variables, setVariables] = useState({
        status: [0, 1],
        salesChannel: map(sessionSalesChannel, 'value')
    });
    const [cachedFilters, setCachedFilters] = useState({});
    const [drawerOpened, setDrawerOpened] = useState(false);
    const [isCreate, setIsCreate] = useState(null);
    const email = get(session, 'email');

    useEffect(() => {
        (currentPage !== null) && onSubmit(isEmpty(cachedFilters) ? variables : cachedFilters);
    }, [currentPage]);

    const onSubmit = (filters) => {
        const cleanFilters = omitBy(filters, (value, key) => {
            if (key === 'status' && includes([0, 1], value)) return false;
            return isEmpty(value);
        });
        setCachedFilters(cleanFilters);
        setVariables(cleanFilters);
    };

    return (
        <Container direction='row' withFooter={false}>
            <LeftFilters
                onSubmit={onSubmit}
                sessionSalesChannel={sessionSalesChannel}
            />
            <Main background='#f4f4f4' withFooter>
                <FlexContainer shrink={0} grow={1} style={{ padding: '5px 25px 0px' }} direction='column'>
                    <FlexContainer pY={23}>
                        <Row
                            border='1px solid #eaeaea'
                            borderRadius={3}
                            padding={15}
                        >
                            <Button
                                width={196}
                                text='Crear Notificación'
                                onClick={() => {
                                    setIsCreate(true);
                                    setDrawerOpened(true);
                                }}
                            />
                        </Row>
                    </FlexContainer>
                    <GetShopperNotifications variables={{
                        size: pageSize,
                        page: currentPage === null ? 1 : currentPage,
                        filters: variables
                    }} onCompleted={(data) => {
                        setTotalRecords(get(data, 'getShopperNotifications.totalRecords', []));
                    }}>
                        {({ data, loading, networkStatus }) => {
                            return (
                                <Loading loading={networkStatus === 4 ? false : loading}>
                                    <If
                                        condition={size(get(data, 'getShopperNotifications.payload', [])) > 0}
                                        then={(
                                            <>
                                                <ShopperNotificationsTable
                                                    data={get(data, 'getShopperNotifications.payload', [])}
                                                    onRowClick={() => {}}
                                                    count={totalRecords}
                                                    drawerOpened={drawerOpened}
                                                    setDrawerOpened={setDrawerOpened}
                                                    setIsCreate={setIsCreate}
                                                    isCreate={isCreate}
                                                    sessionSalesChannel={sessionSalesChannel}
                                                    email={email}
                                                />
                                                <Pagination
                                                    defaultPageSize={100}
                                                    pageSize={pageSize}
                                                    onChangePageSize={({ value }) => {
                                                        const sizeValue = get(value, 'value', 100);

                                                        if (pageSize === 50 && sizeValue === 100) { setCurrentPage(1); }
                                                        setPageSize(sizeValue);
                                                    }}
                                                    onChange={value => setCurrentPage(value)}
                                                    current={currentPage == null ? 1 : currentPage}
                                                    total={totalRecords}
                                                    optionsUp
                                                />
                                            </>
                                        )}
                                        else={(
                                            <>
                                                <NotFound
                                                    firstTextLine='No se encontraron resultados'
                                                    icon='cross'
                                                    iconBackgroundColor='#eaeaea'
                                                />
                                                <Drawer
                                                    values={['25%', '25%', '100%']}
                                                    title={`${isCreate ? 'Crear' : 'Editar'} notificación`}
                                                    visible={drawerOpened}
                                                    onClose={() => setDrawerOpened(false)}
                                                    minWidth='311px'
                                                    bodyStyle={{ paddingRight: 8 }}
                                                >
                                                    <NotificationForm sessionSalesChannel={sessionSalesChannel} initSalesChannels={[]} toggle={() => setDrawerOpened(!drawerOpened)} email={email} isCreate />
                                                </Drawer>
                                            </>
                                        )}
                                    />
                                </Loading>
                            );
                        }}
                    </GetShopperNotifications>
                </FlexContainer>
            </Main>
        </Container>
    );
};

ShopperNotifications.propTypes = {
    session: object
};

export default withRouter(ShopperNotifications);
